import {
  constants,
  heading5Obj,
  mediaQueryStyles as mq
} from '@newsela/angelou';
import {css} from 'emotion';

export const tabletRange = mq.mediaQuery.between(mq.BreakpointNames.xs, mq.BreakpointNames.sm);
const uiColors = constants.colors.ui;

export const listItemStyle = css({
  position: 'relative',
  ...heading5Obj,
  '*': {
    color: uiColors.grey[700],
    stroke: uiColors.grey[700],
  },
});

export const selectedStyle = css({
  '> *': {
    color: uiColors.greyDark[700],
    stroke: uiColors.greyDark[700],
  }
});

export const divAsBorderStyle = css({
  width: '4px',
  backgroundColor: uiColors.coreBlue[500],
  height: '100%',
  top: 0,
  position: 'absolute',
  left: '4px',
  zIndex: '5',
});
